"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = require("satcheljs");
var owa_session_store_1 = require("owa-session-store");
var assign = require('object-assign');
exports.default = satcheljs_1.mutatorAction('updateUserOptions', function updateUserOptions(newUserOptions) {
    assign(owa_session_store_1.getUserConfiguration().UserOptions, newUserOptions);
});
//# sourceMappingURL=updateUserOptions.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/owa-options-core/lib/mutators/updateUserOptions.js
// module id = 1832
// module chunks = 2 39 105 108